import React from 'react';
import { Row, Col, Container, Form, Overlay, Tooltip, FormGroup, FormControl, Button, OverlayTrigger } from "react-bootstrap";
import URLManager from './URLManager';
import DeleteJobDefinition from './DeleteJobDefinition';
import { JobDefinitionService } from '../services/JobDefinitionService';


class JobDefinitionSettings extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.jobRefInput = React.createRef();
        this.jobTitleDefault = "Please select a Job Definition to configure"
        this.state = {
            jobReferenceValid: true,
        };
        this.keyDownHandler = this.keyDownHandler.bind(this);
        this.jobReferenceChangeHandler = this.jobReferenceChangeHandler.bind(this);
        this.updateJobDefinitionHandler = this.updateJobDefinitionHandler.bind(this);
        this.updateJobDefinitionRootJob = this.updateJobDefinitionRootJob.bind(this);
        this.updateJobDefinitionRenderType = this.updateJobDefinitionRenderType.bind(this);
    }    
    componentDidMount() {
        document.addEventListener('keydown', this.keyDownHandler);
    }
    componentWillUnmount() {
        document.removeEventListener('keydown', this.keyDownHandler);
    }
    keyDownHandler(event) {
        // If Control or Command key is pressed
        if (event.ctrlKey || event.metaKey) {
            if (event.key == 's') { // and 's' key then save
                // Save Function
                event.preventDefault();
                this.updateJobDefinitionHandler();
                return false;
            }
        }
    }

    updateJobDefinitionHandler() {
        this.props.onJobDefinitionUpdate();
    }

    // getJobReferenceValidationState() {
    //     if (this.props.currentJobDefinition != null) {
    //         if (this.props.currentJobDefinition.job_reference != this.state.sbJobTitle) {
    //             if (!this.isJobReferenceValid(this.props.currentJobDefinition.job_reference)) {
    //                 this.state.jobReferenceValid = false;
    //                 return 'error';
    //             }
    //         }
    //     }
    //     this.state.jobReferenceValid = true;
    //     return 'success';
    // }
    jobReferenceChangeHandler(e) {
        const isValid = this.props.jobDefinitionService.isJobReferenceUnique(this.props.currentJobDefinition.id, e.target.value);
        this.props.stateManagementService.updateJobDefinition({ ...this.props.currentJobDefinition, job_reference: e.target.value }).then(() => {
            this.setState({
                jobReferenceValid: isValid,
            });
        }).catch(error => {
            console.error('Failed updating job definition:', error);
        });
    }
    updateJobDefinitionRootJob(e) {
        this.props.stateManagementService.updateJobDefinition({ ...this.props.currentJobDefinition, root_job: e.target.value === "true" }).catch(error => {
            console.error('Failed updating job definition:', error);
        });
    }
    updateJobDefinitionRenderType(e) {
        this.props.stateManagementService.updateJobDefinition({ ...this.props.currentJobDefinition, render_type: parseInt(e.target.value, 10) }).catch(error => {
            console.error('Failed updating job definition:', error);
        });
    }
    render() {
        const PLAYWRIGHT_RENDER_TYPE = JobDefinitionService.PLAYWRIGHT_RENDER_TYPE
        const SITEMAP_RENDER_TYPE = JobDefinitionService.SITEMAP_RENDER_TYPE
        return (
            <>
                <Container style={{ visibility: this.props.currentJobDefinition != null ? 'visible' : 'hidden' }}>
                    <Row>
                        <Col md={6}>
                            <Container>
                                <Row>
                                    <Col md={2} className={ "align-self-center" }> 
                                        Reference:
                                    </Col>
                                    <Col md={8} className={ "align-self-center" }> 
                                        <FormGroup
                                            controlId="jobReferenceGroup"
                                            className={
                                                this.state.jobReferenceValid ? "is-valid" : "is-invalid"
                                            }
                                        >
                                            <FormControl
                                                type="text"
                                                value={this.props.currentJobDefinition ? this.props.currentJobDefinition.job_reference : ""}
                                                placeholder="Job Reference, unique within the Extraction, eg. Start Job"
                                                isInvalid={!this.state.jobReferenceValid}
                                                ref={(input) => {
                                                    this.jobRefInput = input;
                                                }}
                                                onChange={this.jobReferenceChangeHandler}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Job Reference is invalid. Please make sure it is unique within the Extraction.
                                            </Form.Control.Feedback>
                                            <Overlay
                                                target={this.jobRefInput}
                                                show={!this.state.jobReferenceValid}
                                                placement="right"
                                            >
                                                {(props) => (
                                                    <Tooltip id="job-reference-tooltip" {...props}>
                                                        Please make sure the Job Reference is unique within the Extraction.
                                                    </Tooltip>
                                                )}
                                            </Overlay>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row className={ "my-3" }>
                                    <Col md={6} className={ "align-self-center" }> 
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip id="button-tooltip">Launch jobs are created for each start URL when a full crawl is executed.</Tooltip>}
                                        >
                                            <FormGroup>
                                                <Form.Check 
                                                    name="isPrimary" 
                                                    type="radio" 
                                                    onChange={this.updateJobDefinitionRootJob} 
                                                    inline 
                                                    checked={this.props.currentJobDefinition?.root_job == true} 
                                                    value="true"
                                                    label="Launch Job" 
                                                />
                                                <Form.Check 
                                                    name="isPrimary" 
                                                    type="radio" 
                                                    onChange={this.updateJobDefinitionRootJob} 
                                                    inline 
                                                    checked={this.props.currentJobDefinition?.root_job == false} 
                                                    value="false" 
                                                    label="Child Job" 
                                                />
                                            </FormGroup>
                                        </OverlayTrigger>
                                    </Col>
                                </Row>
                                <Row className={ "my-3" }>
                                    <Col md={6} className={ "align-self-center" }> 
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip id="button-tooltip">Playwright will run the script in a headless browser, while Sitemap will create new jobs for each link in a sitemap file</Tooltip>}
                                        >
                                            <FormGroup>
                                                <Form.Check 
                                                name="renderType" 
                                                type="radio" 
                                                onChange={this.updateJobDefinitionRenderType} 
                                                inline 
                                                checked={this.props.currentJobDefinition?.render_type == PLAYWRIGHT_RENDER_TYPE} 
                                                value={String(PLAYWRIGHT_RENDER_TYPE)} 
                                                label="Playwright" 
                                            />
                                            <Form.Check 
                                                name="renderType" 
                                                type="radio" 
                                                onChange={this.updateJobDefinitionRenderType} 
                                                inline 
                                                checked={this.props.currentJobDefinition?.render_type == SITEMAP_RENDER_TYPE} 
                                                value={String(SITEMAP_RENDER_TYPE)} 
                                                label="Sitemap" 
                                            />
                                            </FormGroup>
                                        </OverlayTrigger>
                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                        <Col md={6} style={{ padding:0 }}> 
                            <div style={{ display: this.props.currentJobDefinition && this.props.currentJobDefinition.root_job ? 'block' : 'none' }}>
                                <URLManager 
                                    ref={instance => { this.urlManager = instance; }} 
                                    extractionId={this.props.currentExtraction?.id} 
                                    jobDefinition={ this.props.currentJobDefinition } 
                                    stateManagementService={this.props.stateManagementService}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <div className="col">
                            <Button
                                variant="success"
                                onClick={this.updateJobDefinitionHandler}
                            >
                                Save (Ctrl+S or Cmd+S)
                            </Button>
                        </div>
                        <div className="col-md-2 text-end" style={{ padding:0 }}>
                            <DeleteJobDefinition
                            onDelete={() => this.props.onJobDefinitionDelete(this.props.currentJobDefinition?.extraction_id, this.props.currentJobDefinition?.id)}
                            extractionName={this.props.currentExtraction == null ? "" : this.props.currentExtraction.name}
                            jobRef={this.props.currentJobDefinition == null ? this.jobTitleDefault : this.props.currentJobDefinition.job_reference} />
                        </div>
                    </Row>
                </Container>
            </>
        );
    }
}

export default JobDefinitionSettings;